import { defineComponent } from "vue";
import { ModuleMenuScreenCategoryData, ModuleMenuScreenData } from "../menuData";
import ScreenButton, { ScreenButtonClasses } from "./screenButton";
import { FocusHandler } from "./focusHandler";
import { VueProp, refMethod } from "../../core/vueHelpers";

export default /*#__PURE__*/ defineComponent(
{
    name: "categoryList",
    props:
    {
        moduleMenuScreenCategoryData: VueProp<ModuleMenuScreenCategoryData>(),
        labelClass: VueProp(String),
        screenButtonClasses: VueProp<ScreenButtonClasses>(),
        focusHandler: VueProp<FocusHandler>(),
    },
    emits:
    {
        selectScreen: null as unknown as (moduleMenuScreenData: ModuleMenuScreenData, newWindow: boolean) => boolean,
    },
    render()
    {
        const ariaSetSize = this.moduleMenuScreenCategoryData.menus.length + 1;

        return (
            <ul role="menu" aria-label={this.moduleMenuScreenCategoryData.label ?? undefined}>
                <li
                    ref={refMethod<HTMLElement>((elem) => this.focusHandler.setCategoryButton(this.moduleMenuScreenCategoryData, elem))}
                    class={this.labelClass}
                    tabindex="0"
                    role="menuItem"
                    aria-setsize={ariaSetSize}
                    aria-posinset="1"
                    onKeydown={(e: KeyboardEvent) => onKeyDown(this.focusHandler, this.moduleMenuScreenCategoryData, e)}
                    onFocus={() => onFocus(this.focusHandler, this.moduleMenuScreenCategoryData)}
                >
                    {this.moduleMenuScreenCategoryData.label}
                </li>
                {
                    this.moduleMenuScreenCategoryData.menus.map((moduleMenuScreenData: ModuleMenuScreenData, index: number) =>
                        <li role="none">
                            <ScreenButton
                                moduleMenuScreenData={moduleMenuScreenData}
                                screenButtonClasses={this.screenButtonClasses}
                                focusHandler={this.focusHandler}
                                aria-setsize={ariaSetSize}
                                aria-posinset={index + 2}
                                onSelectScreen={(moduleMenuScreenData: ModuleMenuScreenData, newWindow: boolean) => { this.$emit("selectScreen", moduleMenuScreenData, newWindow); }}
                            />
                        </li>
                    )
                }
            </ul>
        );
    }
});

function onKeyDown(focusHandler: FocusHandler, moduleMenuScreenCategoryData: ModuleMenuScreenCategoryData, e: KeyboardEvent): void
{
    e.preventDefault();
    focusHandler.moveFocusFromCategory(moduleMenuScreenCategoryData, e);
}

function onFocus(focusHandler: FocusHandler, moduleMenuScreenCategoryData: ModuleMenuScreenCategoryData): void
{
    focusHandler.setSelectedCategory(moduleMenuScreenCategoryData);
}